module.exports = __webpack_public_path__ + "img/icone-parada-red.44a7cad8.svg";